import Breadcrumbs from '@/components/Breadcrumbs'
import Button from '@/components/Button'
import Portal from '@/components/Portal'
import usePage from '@/hooks/use-page'
import { useNavigate, useParams } from '@/lib/router-dom'
import { getUseCaseId } from "@/utils/use-case-storage"
import { useMemo, useState } from 'react'

const Page = () => {

	const [pageTitle] = useState('Success')

	const { useCaseId } = useParams()
	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: ['Usecase', 'Enroll in Use Case'] })

	const { goTo } = useNavigate()


	/*=================================================
		Navigate
	/================================================*/

	function backToDashboard() {
		goTo(`/use-cases/enrolment`)
	}

	return (
		<>
			<div className="layout-feedback">
				<div className="layout-feedback__header layout-feedback__center">
					Enrolment in Progress.
				</div>
				<div className='layout-feedback__subheader layout-feedback__subheader--center'>
					Your request to enrol in use case is being processed
				</div>

				<div className="layout-feedback__content">
					<img src="/img/success.png" />
				</div>

				<div className="layout-feedback__footer">
					<Button data-testid="backButton" sizing='Medium' text="Done" round full
						submit={() => backToDashboard()}
					/>
				</div>
			</div>
		</>
	)
}
export default Page
